<template>
  <div id="app" class="purchase-history-container">
    <!-- 页面头部 -->
    <div class="page-header">
      
    </div>

    <!-- 筛选区域 -->
    <div class="filter-section">
      <el-form :inline="true" size="small" :model="filterForm">
        <el-form-item label="">
          <el-radio-group v-model="filterForm.dateRangeType" @change="handleDateRangeChange">
            <el-radio-button label="today">今天</el-radio-button>
            <el-radio-button label="yesterday">昨天</el-radio-button>
            <el-radio-button label="last7days">近7天</el-radio-button>
            <el-radio-button label="lastMonth">近1月</el-radio-button>
            <el-radio-button label="custom">自定义</el-radio-button>
          </el-radio-group>
          
          <el-date-picker
            v-if="filterForm.dateRangeType === 'custom'"
            v-model="filterForm.customDateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            size="mini"
            style="margin-left: 10px; width: 240px;"
            @change="handleCustomDateRangeChange"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="">
          <el-select v-model="filterForm.state" placeholder="请选择" size="mini" @change="handleStateChange">
            <el-option label="全部" value=""></el-option>
            <el-option label="草稿" value="0"></el-option>
            <el-option label="已提交" value="2"></el-option>
            <el-option label="已审核" value="4"></el-option>
            <el-option label="已过单" value="5"></el-option>
            <el-option label="已冲销" value="6"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="filterForm.drugName" placeholder="请输入药品名称" size="mini"></el-input>
        </el-form-item>
        <el-form-item style="margin-left:12px;">
          <el-button type="primary" size="mini" @click="handleQuery" icon="el-icon-Ssearch">查询</el-button>
          <el-button size="mini" @click="handleReset">重置</el-button>
		  <el-button  type="success" size="mini" icon="el-icon-adds" @click="handleAddNew">新增</el-button>
		  <el-button type="primary" size="mini" icon="el-icon-refresh" @click="handleRefresh">刷新</el-button>
        </el-form-item>
      </el-form>
    </div>
	
	<div class="table-section-header">
		<h2 class="page-title">卫材采购出库</h2>
	</div>
    <!-- 表格区域 -->
    <div class="table-section" :style="{ height: tableHeight + 'px' }">
      <div class="table-container" :class="tableStyleClass">
        <el-table
          :data="tableData"
          :height="tableInnerHeight"
          border
          style="width: 100%"
          :row-style="{ height: rowHeight + 'px' }"
          :cell-style="{ padding: cellPadding + 'px' }"
          :header-cell-style="{ 
            'font-size': headerFontSize + 'px',
            'font-weight': 'bold',
            'background-color': '#f5f7fa'
          }"
          @current-change="handleCurrentTableChange"
          highlight-current-row
          ref="mainTable"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" label="行号" width="60" align="center"></el-table-column>
          
          <el-table-column 
            v-for="column in visibleColumns" 
            :key="column.prop"
            :prop="column.prop" 
            :label="column.label"
            :width="column.width"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <!-- 状态列特殊处理 - 修改为不可点击 -->
              <template v-if="column.prop === 'state'">
                <div class="stateValue" :style="getStatusStyle(scope.row.state)">
                  <i :class="getStatusIcon(scope.row.state)"></i>
                  <span>{{ getStatusText(scope.row.state) }}</span>
                </div>
              </template>
              <template v-else>
                <span>{{ scope.row[column.prop] }}</span>
              </template>
            </template>
          </el-table-column>
          
          <!-- 操作列 - 根据状态显示不同按钮 -->
          <el-table-column label="操作" width="200" fixed="right">
            <template slot-scope="scope">
              <!-- 详情按钮 - 所有状态都显示 -->
              <el-button type="text" size="mini" @click="handleViewDetail(scope.row)">详情</el-button>
              
              <!-- 草稿状态：0 -->
              <template v-if="scope.row.state === 0">
                <el-button type="text" size="mini" @click="handleSubmit(scope.row)">去提交</el-button>
                <el-button type="text" size="mini" @click="handleDeleteRow(scope.row)" style="color: #f56c6c;">删除</el-button>
              </template>
              
              <!-- 已提交状态：2 -->
              <el-button 
                v-else-if="scope.row.state === 2"
                type="text" 
                size="mini" 
                @click="handleExamine(scope.row)"
              >去审核</el-button>
              
              <!-- 已审核状态：4 -->
              <el-button 
                v-else-if="scope.row.state === 4"
                type="text" 
                size="mini" 
                @click="handlePass(scope.row)"
              >去过单</el-button>
              
              <!-- 已过单状态：5 -->
              <el-button 
                v-else-if="scope.row.state === 5"
                type="text" 
                size="mini" 
                @click="handleReverse(scope.row)"
                style="color: #f56c6c;"
              >冲销此单</el-button>
              
              <!-- 编辑按钮 - 只有草稿状态显示 -->
              <el-button 
                v-if="scope.row.state === 0"
                type="text" 
                size="mini" 
                @click="handleEdit(scope.row)"
              >编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pagination-section">
      <el-pagination
        :current-page="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>

    <!-- 列设置模态框 -->
    <el-dialog 
      title="列设置" 
      :visible.sync="showColumnSettings" 
      width="600px"
      :before-close="handleCloseDialog"
    >
      <div class="column-settings">
        <el-tabs v-model="activeTab">
          <el-tab-pane label="表格字体行高设置" name="fontSettings">
            <div class="setting-item">
              <h4>字体大小设置</h4>
              <el-radio-group v-model="fontSize" @change="updateTableStyle">
                <el-radio label="small">默认字号</el-radio>
                <el-radio label="medium">较大字号</el-radio>
                <el-radio label="large">特大字号</el-radio>
              </el-radio-group>
            </div>
            
            <div class="setting-item">
              <h4>表格高度设置</h4>
              <el-radio-group v-model="rowHeightType" @change="updateTableStyle">
                <el-radio label="compact">紧凑行高</el-radio>
                <el-radio label="normal">适中行高</el-radio>
                <el-radio label="loose">宽松行高</el-radio>
              </el-radio-group>
            </div>
            
            <div class="setting-hint">
              <i class="el-icon-info"></i>
              <span>此设置会应用于所有单据、账簿、报表等页面的表格中</span>
            </div>
          </el-tab-pane>
          
          <el-tab-pane label="列显示设置" name="columnSettings">
            <div class="column-list">
              <el-checkbox-group v-model="selectedColumns">
                <el-checkbox 
                  v-for="column in allColumns" 
                  :key="column.prop" 
                  :label="column.prop"
                >
                  {{ column.label }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCloseDialog">取消</el-button>
        <el-button type="primary" @click="handleSaveSettings">确定</el-button>
      </div>
    </el-dialog>

    <!-- 详情模态框 - 用于查看、提交、审核、过单、冲销操作 -->
    <el-dialog 
      :title="dialogTitle" 
      :visible.sync="detailDialogVisible" 
      width="50%" 
      :before-close="handleDetailClose"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      class="detail-dialog"
    >
      <div class="detail-container">
        <!-- 表单区域 -->
        <div class="form-section">
          <el-form ref="detailForm" :model="detailForm" label-width="100px" size="mini" :inline="true">
            <el-row :gutter="20">
              <el-col :span="8" v-for="(field, index) in formFields" :key="index">
                <el-form-item :label="field.label" v-if="field.visible !== false">
                  <el-input 
                    v-if="field.type === 'input'"
                    v-model="detailForm[field.prop]"
                    :placeholder="field.placeholder"
                    :disabled="field.disabled || currentDetailMode === 'view'"
                    size="mini"
                  ></el-input>
                  <el-select 
                    v-if="field.type === 'select'"
                    v-model="detailForm[field.prop]"
                    :disabled="field.disabled || currentDetailMode === 'view'"
                    filterable
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option 
                      v-for="option in getOptions(field.optionsKey)"
                      :key="option.id"
                      :label="option.label"
                      :value="option.id"
                    ></el-option>
                  </el-select>
                  <el-date-picker
                    v-if="field.type === 'date'"
                    v-model="detailForm[field.prop]"
                    type="date"
                    placeholder="选择日期"
                    style="width: 100%"
                    :disabled="field.disabled || currentDetailMode === 'view'"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <!-- 表格区域 -->
        <div class="detail-table-section">
          <el-table
            :data="detailTableData"
            border
            style="width: 100%"
            size="mini"
          >
            <el-table-column 
              v-for="column in detailTableColumns" 
              :key="column.prop"
              :prop="column.prop" 
              :label="column.label"
              :width="column.width"
              align="center"
            >
            </el-table-column>
          </el-table>
          
          <!-- 合计金额 -->
          <div class="total-section">
            <span style="color: #004a00;">成本合计金额：</span>
            <el-input 
              :value="costTotal | currencyFormat" 
              style="width: 150px; margin-right: 20px;" 
              size="mini" 
              disabled
            ></el-input>
            <span style="color: brown;">零售合计金额：</span>
            <el-input 
              :value="saleTotal | currencyFormat" 
              style="width: 150px;" 
              size="mini" 
              disabled
            ></el-input>
          </div>
        </div>
      </div>
      
      <!-- 底部按钮区域 -->
      <div slot="footer" class="dialog-footer">
        <!-- 查看模式 -->
        <template v-if="currentDetailMode === 'view'">
          <el-button size="mini" @click="detailDialogVisible = false">关闭</el-button>
        </template>
        
        <!-- 提交模式（草稿状态） -->
        <template v-else-if="currentDetailMode === 'draft'">
          <el-button size="mini" type="primary" @click="handleSubmitExamine">提交审核</el-button>
          <el-button size="mini" @click="detailDialogVisible = false">取消</el-button>
        </template>
        
        <!-- 审核模式（已提交状态） -->
        <template v-else-if="currentDetailMode === 'examine'">
          <el-button size="mini" type="danger" @click="handleRefuseExamine">拒绝审核</el-button>
          <el-button size="mini" type="primary" @click="handleExamineSubmit">确认审核</el-button>
          <el-button size="mini" @click="detailDialogVisible = false">取消</el-button>
        </template>
        
        <!-- 过单模式（已审核状态） -->
        <template v-else-if="currentDetailMode === 'pass'">
          <el-button size="mini" type="danger" @click="handleRefusePass">拒绝过单</el-button>
          <el-button size="mini" type="primary" @click="handlePassSubmit">确认过单</el-button>
          <el-button size="mini" @click="detailDialogVisible = false">取消</el-button>
        </template>
        
        <!-- 冲销模式（已过单状态） -->
        <template v-else-if="currentDetailMode === 'reverse'">
          <el-button size="mini" type="danger" @click="handleReverseSubmit">确认冲销</el-button>
          <el-button size="mini" @click="detailDialogVisible = false">取消</el-button>
        </template>
      </div>
    </el-dialog>

    <!-- 新增/编辑模态框 -->
    <el-dialog
      :title="getDialogTitle()"
      :visible.sync="showAddDialog"
      :fullscreen="false"
      :modal="true"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :before-close="handleAddDialogClose"
      width="66%"
      top="2vh"
      class="add-edit-dialog"
    >
      <AddRet 
        ref="addRetRef"
        :current-row="currentTable"
        :mode="currentMode"
        :selected-ids="selectedIds"
        :loading="showLoading"
        @close="handleCloseAddDialog"
        @refresh="handleRefresh"
      />
    </el-dialog>
  </div>
</template>

<script>
import AddRet from './AddRet.vue'
import { shopWCReturnList, getWCRetnDetail, toRetnWCExamine, deleteWCReturn, selectDropDownList } from "@/api/PSI/shopReturn.js";
import dayjs from "dayjs";

// 千位分隔符过滤器
const currencyFormat = (value) => {
  if (value === null || value === undefined) return '0.00000000';
  const num = Number(value);
  if (isNaN(num)) return '0.00000000';
  return num.toLocaleString('zh-CN', {
    minimumFractionDigits: 8,
    maximumFractionDigits: 8
  });
};

export default {
  name: 'PurchaseHistory',
  components: {
    AddRet
  },
  filters: {
    currencyFormat
  },
  data() {
    return {
      // 筛选表单
      filterForm: {
        dateRangeType: 'today',
        customDateRange: [],
        state: '',
        drugName: '',
        documentType: '',
        supplier: '',
        warehouse: ''
      },
      // 新增/编辑对话框控制
	  showAddDialog: false,
      // 供应商选项
      supplierOptions: [],
      
      // 表格数据
      tableData: [],
      
      // 表格列配置
      allColumns: [
        { prop: 'state', label: '单据状态', width: 100 },
        { prop: 'docNum', label: '单据编号', width: 188 },
        { prop: 'busDate', label: '业务日期', width: 120 },
        { prop: 'supplierName', label: '供货单位', width: 120 },
        { prop: 'costAmt', label: '成本金额', width: 100 },
        { prop: 'saleAmt', label: '销售金额', width: 100 },
        { prop: 'createName', label: '申请人', width: 100 },
        { prop: 'createTime', label: '制单时间', width: 160 },
        { prop: 'reviewName', label: '审核人', width: 100 },
        { prop: 'reviewTime', label: '审核时间', width: 160 },
        { prop: 'passingOrdersName', label: '过单人', width: 100 },
        { prop: 'passingOrdersTime', label: '过单时间', width: 160 }
      ],
      selectedColumns: [],
      loading: false,
      
      // 分页
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      
      // 表格样式设置
      showColumnSettings: false,
      activeTab: 'fontSettings',
      fontSize: 'small',
      rowHeightType: 'normal',
      
      // 表格高度
      tableHeight: 400,
      tableInnerHeight: 400,
      // 新增页面控制 - 只用于新增和编辑
      showAddPage: false,
      currentTable: null,
      currentMode: 'add',
      showLoading: false,
      selectedIds: [],
      // 详情模态框相关 - 用于查看、提交、审核、过单、冲销
      detailDialogVisible: false,
      dialogTitle: '',
      currentDetailMode: 'view', // view, draft, examine, pass, reverse
      detailForm: {
        id: '',
        docNum: '',
        busDate: '',
        supplierId: '',
        supplierName: '',
        createName: '',
		reviewName: '',
        state: ''
      },
      detailTableData: [],
      costTotal: 0,
      saleTotal: 0,
      
      // 表单字段配置
      formFields: [
        { prop: 'docNum', label: '单据编号', type: 'input', disabled: true },
        { prop: 'busDate', label: '业务日期', type: 'date', disabled: true },
        { prop: 'supplierId', label: '供应商', type: 'select', optionsKey: 'supplierOptions', disabled: true },
        { prop: 'createName', label: '制单人', type: 'input', disabled: true },
        { prop: 'reviewName', label: '审核人', type: 'input', disabled: true },
      ],
      
      // 详情表格列配置
      detailTableColumns: [
        { prop: 'drugName', label: '药品名称', width: 150 },
        { prop: 'drugSpec', label: '规格描述', width: 120 },
        { prop: 'retnCnt', label: '退库数量', width: 100 },
        { prop: 'unt', label: '退库单位', width: 100 },
        { prop: 'retnPric', label: '成本单价', width: 100 },
        { prop: 'retnAmt', label: '成本金额', width: 100 },
        { prop: 'salePric', label: '零售单价', width: 100 },
        { prop: 'saleAmt', label: '零售金额', width: 100 },
        { prop: 'prodentpName', label: '生产厂家', width: 220 },
        { prop: 'manuLotnum', label: '生产批号', width: 120 }
      ]
    }
  },
  computed: {
    // 可见列
    visibleColumns() {
      return this.allColumns.filter(col => this.selectedColumns.includes(col.prop));
    },
    
    // 表格样式类
    tableStyleClass() {
      return `font-${this.fontSize} row-${this.rowHeightType}`;
    },
    
    // 行高
    rowHeight() {
      const heightMap = {
        compact: 32,
        normal: 40,
        loose: 48
      };
      return heightMap[this.rowHeightType] || 40;
    },
    
    // 单元格内边距
    cellPadding() {
      const paddingMap = {
        compact: 4,
        normal: 8,
        loose: 12
      };
      return paddingMap[this.rowHeightType] || 8;
    },
    
    // 表头字体大小
    headerFontSize() {
      const sizeMap = {
        small: 12,
        medium: 14,
        large: 16
      };
      return sizeMap[this.fontSize] || 12;
    }
  },
  mounted() {
    // 初始化选中所有列
    this.selectedColumns = this.allColumns.map(col => col.prop);
    
    // 计算表格高度
    this.calculateTableHeight();
    window.addEventListener('resize', this.calculateTableHeight);
    
    // 加载数据
    this.loadData();
    
    // 获取供应商选项
    this.getSupplierOptions();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateTableHeight);
  },
  methods: {
      // 获取供应商选项
      async getSupplierOptions() {
        try {
          const res = await selectDropDownList();
          if (res.code === 200) {
            this.supplierOptions = res.data.content.map(item => ({
              id: item.supplierId,
              label: item.supplierName,
              value: item.supplierId
            }));
          } else {
            console.error('获取供应商列表失败:', res.message);
            this.$message.error('获取供应商列表失败');
          }
        } catch (error) {
          console.error('获取供应商列表失败:', error);
          this.$message.error('获取供应商列表失败');
        }
      },
  
      // 加载数据
      async loadData() {
        try {
          this.loading = true;
          
          // 构建日期参数
          let startDate = '';
          let endDate = '';
          
          const today = dayjs();
          
          switch(this.filterForm.dateRangeType) {
            case 'today':
              // 修复格式：YYYY-MM-DD HH:mm:ss
              startDate = today.format('YYYY-MM-DD 00:00:00');
              endDate = today.format('YYYY-MM-DD 23:59:59');
              break;
              
            case 'yesterday':
              const yesterday = today.subtract(1, 'day');
              // 修复格式：YYYY-MM-DD HH:mm:ss
              startDate = yesterday.format('YYYY-MM-DD 00:00:00');
              endDate = yesterday.format('YYYY-MM-DD 23:59:59');
              break;
              
            case 'last7days':
              const sevenDaysAgo = today.subtract(7, 'day');
              // 修复格式：YYYY-MM-DD HH:mm:ss
              startDate = sevenDaysAgo.format('YYYY-MM-DD 00:00:00');
              endDate = today.format('YYYY-MM-DD 23:59:59');
              break;
              
            case 'lastMonth':
              const oneMonthAgo = today.subtract(1, 'month');
              // 修复格式：YYYY-MM-DD HH:mm:ss
              startDate = oneMonthAgo.format('YYYY-MM-DD 00:00:00');
              endDate = today.format('YYYY-MM-DD 23:59:59');
              break;
              
            case 'custom':
              if (this.filterForm.customDateRange && this.filterForm.customDateRange.length === 2) {
                const [start, end] = this.filterForm.customDateRange;
                // 修复格式：YYYY-MM-DD HH:mm:ss
                startDate = dayjs(start).format('YYYY-MM-DD 00:00:00');
                endDate = dayjs(end).format('YYYY-MM-DD 23:59:59');
              } else {
                // 默认使用今天
                startDate = today.format('YYYY-MM-DD 00:00:00');
                endDate = today.format('YYYY-MM-DD 23:59:59');
              }
              break;
              
            default:
              // 默认使用今天
              startDate = today.format('YYYY-MM-DD 00:00:00');
              endDate = today.format('YYYY-MM-DD 23:59:59');
          }
          
          console.log('请求参数日期范围:', { startDate, endDate });
          
          const params = {
            state: this.filterForm.state || '',
            startDate: startDate,
            endDate: endDate,
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            eisaiName: this.filterForm.documentNo || '',
            supplierName: this.filterForm.supplier || ''
          };
      
          const res = await shopWCReturnList(params);
      
          if (res.code === 200) {
            this.tableData = res.data.content || [];
            this.totalCount = res.data.totalSize || 0;
            
            if (this.tableData.length === 0) {
              this.$message.info('未查询到相关数据');
            } else {
              this.$message.success(`查询成功，共 ${this.totalCount} 条数据`);
            }
          } else {
            this.$message.error(res.message || '获取数据失败');
            this.tableData = [];
            this.totalCount = 0;
          }
        } catch (error) {
          console.error('加载数据失败:', error);
          this.$message.error('加载数据失败: ' + (error.message || '网络错误'));
          this.tableData = [];
          this.totalCount = 0;
        } finally {
          this.loading = false;
        }
      },
  
      // 计算表格高度
      calculateTableHeight() {
        const windowHeight = window.innerHeight;
        const headerHeight = 60;
        const filterHeight = 100;
        const footerHeight = 40;
        const paginationHeight = 50;
        const margin = 20;
        
        this.tableHeight = windowHeight - headerHeight - filterHeight - footerHeight - paginationHeight - margin;
        this.tableInnerHeight = this.tableHeight - 10;
      },
  
      // 处理日期范围变化
      handleDateRangeChange() {
        if (this.filterForm.dateRangeType !== 'custom') {
          this.filterForm.customDateRange = [];
        }
        this.currentPage = 1;
        this.loadData();
      },
  
      // 处理自定义日期范围变化
      handleCustomDateRangeChange() {
        this.currentPage = 1;
        this.loadData();
      },
  
      // 处理状态变化
      handleStateChange() {
        this.currentPage = 1;
        this.loadData();
      },
  
      // 查询
      handleQuery() {
        this.currentPage = 1;
        this.loadData();
      },
	// 新增：获取对话框标题
	  getDialogTitle() {
	    const titleMap = {
	      'add': '新增采购出库',
	      'edit': '编辑采购出库',
	      'view': '查看采购出库'
	    };
	    return titleMap[this.currentMode] || '采购出库';
	  },
	  
	  // 新增：打开新增/编辑对话框
	  handleAddNew() {
	    this.currentTable = null;
	    this.currentMode = 'add';
	    this.showAddDialog = true;
	  },
	  
	  // 编辑 - 打开对话框
	  handleEdit(row) {
	    if (row.state !== 0) {
	      this.$message.warning('只有草稿状态的数据可以编辑');
	      return;
	    }
	    
	    try {
	      this.currentTable = row;
	      this.currentMode = 'edit';
	      
	      // 显示加载状态
	      this.showLoading = true;
	      
	      // 加载编辑数据
	      this.loadEditData(row.id).then(() => {
	        this.showAddDialog = true;
	      }).catch(error => {
	        console.error('加载编辑数据失败:', error);
	        this.$message.error('加载编辑数据失败');
	      }).finally(() => {
	        this.showLoading = false;
	      });
	      
	    } catch (error) {
	      console.error('打开编辑页面失败:', error);
	      this.$message.error('打开编辑页面失败');
	    }
	  },
	  
	  // 新增：处理对话框关闭
	  handleAddDialogClose() {
	    this.$confirm('关闭此界面会清空已填写的内容, 是否继续?', '提示', {
	      confirmButtonText: '确定',
	      cancelButtonText: '取消',
	      type: 'warning'
	    }).then(() => {
	      this.showAddDialog = false;
	      this.currentTable = null;
	      this.currentMode = 'add';
	    }).catch(() => {
	      // 取消关闭
	    });
	  },
	  
	  // 新增：关闭对话框
	  handleCloseAddDialog() {
	    this.showAddDialog = false;
	    this.currentTable = null;
	    this.currentMode = 'add';
	    
	    // 自动刷新数据
	    this.loadData();
	  },
      // 重置
      handleReset() {
        this.filterForm = {
          dateRangeType: 'today',
          customDateRange: [],
          state: '',
          drugName: '',
          documentType: '',
          supplier: '',
          warehouse: ''
        };
        this.currentPage = 1;
        this.loadData();
        this.$message.info('筛选条件已重置');
      },
  
      // 刷新
      handleRefresh() {
        this.loadData();
        this.$message.success('数据已刷新');
      },
  
      // 分页大小变化
      handleSizeChange(val) {
        this.pageSize = val;
        this.currentPage = 1;
        this.loadData();
      },
  
      // 当前页变化
      handleCurrentChange(val) {
        this.currentPage = val;
        this.loadData();
      },
  
      // 表格行选择变化
      handleCurrentTableChange(val) {
        this.currentTable = val;
      },
  
     
      // 新增：加载编辑数据
      async loadEditData(id) {
        try {
          // 调用获取详情接口
          const res = await getWCRetnDetail({ id });
          
          if (res.code === 200 && res.data) {
            const data = res.data;
            
            // 将完整的数据赋值给currentTable，包括list
            this.currentTable = {
              ...this.currentTable,
              ...data,
              list: data.list || []  // 确保list存在
            };
            
            console.log('编辑数据加载成功:', {
              基本数据: data,
              列表数据: data.list,
              列表长度: data.list?.length || 0
            });
            
            return data;
          } else {
            throw new Error(res.message || '获取详情失败');
          }
        } catch (error) {
          console.error('加载编辑数据失败:', error);
          throw error;
        }
      },
  
      // 查看详情 - 打开详情模态框
      async handleViewDetail(row) {
        try {
          this.currentDetailMode = 'view';
          this.dialogTitle = `查看单据 - ${row.docNum}`;
          await this.loadDetailData(row);
          this.detailDialogVisible = true;
        } catch (error) {
          console.error('打开详情失败:', error);
          this.$message.error('打开详情失败');
        }
      },
  
      // 去提交（草稿状态） - 打开详情模态框
      async handleSubmit(row) {
        try {
          this.currentDetailMode = 'draft';
          this.dialogTitle = `提交审核 - ${row.docNum}`;
          await this.loadDetailData(row);
          this.detailDialogVisible = true;
        } catch (error) {
          console.error('打开提交页面失败:', error);
          this.$message.error('打开提交页面失败');
        }
      },
  
      // 去审核（已提交状态） - 打开详情模态框
      async handleExamine(row) {
        try {
          this.currentDetailMode = 'examine';
          this.dialogTitle = `审核单据 - ${row.docNum}`;
          await this.loadDetailData(row);
          this.detailDialogVisible = true;
        } catch (error) {
          console.error('打开审核页面失败:', error);
          this.$message.error('打开审核页面失败');
        }
      },
  
      // 去过单（已审核状态） - 打开详情模态框
      async handlePass(row) {
        try {
          this.currentDetailMode = 'pass';
          this.dialogTitle = `过单处理 - ${row.docNum}`;
          await this.loadDetailData(row);
          this.detailDialogVisible = true;
        } catch (error) {
          console.error('打开过单页面失败:', error);
          this.$message.error('打开过单页面失败');
        }
      },
  
      // 冲销此单（已过单状态） - 打开详情模态框
      async handleReverse(row) {
        try {
          this.currentDetailMode = 'reverse';
          this.dialogTitle = `冲销单据 - ${row.docNum}`;
          await this.loadDetailData(row);
          this.detailDialogVisible = true;
        } catch (error) {
          console.error('打开冲销页面失败:', error);
          this.$message.error('打开冲销页面失败');
        }
      },
  
      // 加载详情数据
      async loadDetailData(row) {
        try {
          const res = await getWCRetnDetail({ id: row.id });
          
          if (res.code === 200) {
            // 填充表单数据
            Object.keys(this.detailForm).forEach(key => {
              if (res.data[key] !== undefined) {
                this.detailForm[key] = res.data[key];
              }
            });
            
            // 设置供应商名称
            if (res.data.supplierId) {
              const supplier = this.supplierOptions.find(item => item.id === res.data.supplierId);
              if (supplier) {
                this.detailForm.supplierName = supplier.label;
              }
            }
            
            // 填充表格数据
            this.detailTableData = res.data.list || [];
            
            // 计算合计金额
            this.costTotal = this.detailTableData.reduce((total, item) => {
              return total + (parseFloat(item.retnAmt) || 0);
            }, 0);
            
            this.saleTotal = this.detailTableData.reduce((total, item) => {
              return total + (parseFloat(item.saleAmt) || 0);
            }, 0);
            
            this.detailForm.id = row.id;
            this.detailForm.state = row.state;
          } else {
            throw new Error(res.message || '获取详情失败');
          }
        } catch (error) {
          console.error('加载详情数据失败:', error);
          this.$message.error('加载详情数据失败: ' + error.message);
          throw error;
        }
      },
  
      // 删除单行
      async handleDeleteRow(row) {
        if (row.state !== 0) {
          this.$message.warning('只有草稿状态的单据可以删除！');
          return;
        }
        
        try {
          await this.$confirm('确定要删除此单据吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          });
          
          const result = await deleteWCReturn({ id: row.id });
          
          if (result.code === 200) {
            this.$message.success('删除成功');
            this.loadData();
          } else {
            this.$message.error(result.message || '删除失败');
          }
        } catch (error) {
          if (error !== 'cancel') {
            console.error('删除失败:', error);
            this.$message.error('删除失败');
          }
        }
      },
  
      // 删除（批量删除）
      async handleDelete() {
        if (!this.currentTable) {
          this.$message.warning('请先选择一条单据！');
          return;
        }
        
        if (this.currentTable.state !== 0) {
          this.$message.warning('只有草稿状态的单据可以删除！');
          return;
        }
        
        try {
          await this.$confirm('确定要删除选中的单据吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          });
          
          const result = await deleteWCReturn({ id: this.currentTable.id });
          
          if (result.code === 200) {
            this.$message.success('删除成功');
            this.loadData();
            this.currentTable = null;
          } else {
            this.$message.error(result.message || '删除失败');
          }
        } catch (error) {
          if (error !== 'cancel') {
            console.error('删除失败:', error);
            this.$message.error('删除失败');
          }
        }
      },
  
      // 详情模态框 - 提交审核
      async handleSubmitExamine() {
        try {
          this.detailForm.state = 2; // 已提交
          const result = await toRetnWCExamine(this.detailForm);
          
          if (result.code === 200) {
            this.$message.success('提交成功');
            this.detailDialogVisible = false;
            this.loadData();
          } else {
            this.$message.error(result.message || '提交失败');
          }
        } catch (error) {
          console.error('提交失败:', error);
          this.$message.error('提交失败');
        }
      },
  
      // 详情模态框 - 确认审核
      async handleExamineSubmit() {
        try {
          this.detailForm.state = 4; // 已审核
          const result = await toRetnWCExamine(this.detailForm);
          
          if (result.code === 200) {
            this.$message.success('审核通过');
            this.detailDialogVisible = false;
            this.loadData();
          } else {
            this.$message.error(result.message || '审核失败');
          }
        } catch (error) {
          console.error('审核失败:', error);
          this.$message.error('审核失败');
        }
      },
  
      // 详情模态框 - 拒绝审核
      handleRefuseExamine() {
        this.$confirm('此操作将回退该条数据状态, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          try {
            this.detailForm.state = 0; // 回退到草稿
            const result = await toRetnWCExamine(this.detailForm);
            
            if (result.code === 200) {
              this.$message.success('已回退到草稿状态');
              this.detailDialogVisible = false;
              this.loadData();
            } else {
              this.$message.error(result.message || '回退失败');
            }
          } catch (error) {
            console.error('回退失败:', error);
            this.$message.error('回退失败');
          }
        }).catch(() => {
          this.$message.info('已取消操作');
        });
      },
  
      // 详情模态框 - 确认过单
      async handlePassSubmit() {
        try {
          this.detailForm.state = 5; // 已过单
          const result = await toRetnWCExamine(this.detailForm);
          
          if (result.code === 200) {
            this.$message.success('过单成功');
            this.detailDialogVisible = false;
            this.loadData();
          } else {
            this.$message.error(result.message || '过单失败');
          }
        } catch (error) {
          console.error('过单失败:', error);
          this.$message.error('过单失败');
        }
      },
  
      // 详情模态框 - 拒绝过单
      handleRefusePass() {
        this.$confirm('此操作将回退该条数据状态, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          try {
            this.detailForm.state = 2; // 回退到已提交
            const result = await toRetnWCExamine(this.detailForm);
            
            if (result.code === 200) {
              this.$message.success('已回退到提交状态');
              this.detailDialogVisible = false;
              this.loadData();
            } else {
              this.$message.error(result.message || '回退失败');
            }
          } catch (error) {
            console.error('回退失败:', error);
            this.$message.error('回退失败');
          }
        }).catch(() => {
          this.$message.info('已取消操作');
        });
      },
  
      // 详情模态框 - 确认冲销
      async handleReverseSubmit() {
        try {
          this.detailForm.state = 6; // 已冲销
          const result = await toRetnWCExamine(this.detailForm);
          
          if (result.code === 200) {
            this.$message.success('冲销成功');
            this.detailDialogVisible = false;
            this.loadData();
          } else {
            this.$message.error(result.message || '冲销失败');
          }
        } catch (error) {
          console.error('冲销失败:', error);
          this.$message.error('冲销失败');
        }
      },
  
      // 关闭详情模态框
      handleDetailClose() {
        this.detailDialogVisible = false;
        this.resetDetailForm();
      },
  
      // 重置详情表单
      resetDetailForm() {
        this.detailForm = {
          id: '',
          docNum: '',
          busDate: '',
          supplierId: '',
          supplierName: '',
          createName: '',
          totalAmt: '',
          state: ''
        };
        this.detailTableData = [];
        this.costTotal = 0;
        this.saleTotal = 0;
      },
  
      // 关闭新增页面
      handleCloseAddPage() {
        this.showAddPage = false;
        this.currentTable = null;
        this.currentMode = 'add';
        
        // 自动刷新数据
        this.loadData();
      },
  
      // 状态相关方法
      getStatusText(state) {
        const statusMap = {
          0: '草稿',
          2: '已提交',
          4: '已审核',
          5: '已过单',
          6: '已冲销'
        };
        return statusMap[state] || '未知状态';
      },
  
      getStatusIcon(state) {
        const iconMap = {
          0: 'el-icon-document',
          2: 'el-icon-top-left',
          4: 'el-icon-check',
          5: 'el-icon-document-checked',
          6: 'el-icon-delete'
        };
        return iconMap[state] || 'el-icon-question';
      },
  
      getStatusStyle(state) {
        const colorMap = {
          0: { backgroundColor: '#e2fff6', color: '#004a00' },
          2: { backgroundColor: '#f0f9ff', color: '#00557f' },
          4: { backgroundColor: '#fdf6ec', color: '#b88230' },
          5: { backgroundColor: '#f0f9ff', color: '#00557f' },
          6: { backgroundColor: '#fef0f0', color: '#f56c6c' }
        };
        return colorMap[state] || { backgroundColor: '#f5f7fa', color: '#909399' };
      },
  
      // 获取选项数据
      getOptions(optionsKey) {
        switch (optionsKey) {
          case 'supplierOptions':
            return this.supplierOptions;
          default:
            return [];
        }
      },
  
      // 更新表格样式
      updateTableStyle() {
        // 样式更新是响应式的
      },
  
      // 关闭设置对话框
      handleCloseDialog() {
        this.showColumnSettings = false;
      },
  
      // 保存设置
      handleSaveSettings() {
        this.showColumnSettings = false;
        this.$message.success('设置已保存');
      }
    }
  }
  </script>
  
  <style lang="less">
  .purchase-history-container {
    height: calc(90vh - 20px);
    display: flex;
    flex-direction: column;
    background-color: #f5f7fa;
    padding: 15px;
    overflow: hidden;
    position: relative;
    
    .filter-section {
      background: #fff;
      padding: 15px;
      border-radius: 4px;
      margin-bottom: 15px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      
      .el-form-item {
        margin-bottom: 10px;
      }
    }
	
    .table-section-header {
      display: flex;
      justify-content: start;
      align-items: center;
      margin-bottom: 15px;
      
      .page-title {
        font-size: 18px;
        font-weight: bold;
        color: #303133;
        margin: 0;
      }
      
      .header-actions {
        .el-button {
          margin-left: 10px;
        }
      }
    }
    .table-section {
      flex: 1;
      background: #fff;
      border-radius: 4px;
      overflow: hidden;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      
      .table-container {
        height: 100%;
        
        &.font-small {
          .el-table {
            font-size: 12px;
          }
        }
        
        &.font-medium {
          .el-table {
            font-size: 14px;
          }
        }
        
        &.font-large {
          .el-table {
            font-size: 16px;
          }
        }
        
        &.row-compact {
          .el-table__row {
            height: 32px;
          }
        }
        
        &.row-normal {
          .el-table__row {
            height: 40px;
          }
        }
        
        &.row-loose {
          .el-table__row {
            height: 48px;
          }
        }
        
        .stateValue {
          border-radius: 4px;
          text-align: center;
          padding: 2px 8px;
          font-size: 12px;
          display: inline-flex;
          align-items: center;
          
          i {
            margin-right: 4px;
          }
        }
      }
    }
    .pagination-section {
      display: flex;
      justify-content: flex-end;
      padding: 10px 0;
    }
    
    .column-settings {
      .setting-item {
        margin-bottom: 20px;
        
        h4 {
          margin-bottom: 10px;
          font-size: 14px;
          color: #606266;
        }
        
        .el-radio-group {
          .el-radio {
            margin-right: 20px;
          }
        }
      }
      
      .setting-hint {
        display: flex;
        align-items: center;
        padding: 10px;
        background-color: #f0f9ff;
        border-radius: 4px;
        color: #409eff;
        font-size: 12px;
        
        i {
          margin-right: 5px;
        }
      }
      
      .column-list {
        max-height: 300px;
        overflow-y: auto;
        
        .el-checkbox-group {
          display: flex;
          flex-direction: column;
          
          .el-checkbox {
            margin-bottom: 10px;
          }
        }
      }
    }
    
    .add-page-container {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: white;
      z-index: 1000;
      overflow: auto;
    }
    
	.add-edit-dialog{
		.el-dialog__header {
		  padding: 10px;
		  background-color: #007bb0;
		  border-radius: 8px 8px 0 0px;
		  .el-dialog__title {
		    color: #fff;
		    font-size: 16px;
		  }
		  
		  .el-dialog__headerbtn {
		    top: 13px;
		    
		    .el-dialog__close {
		      color: #fff;
		    }
		  }
		}
	}
    .detail-dialog {
      .el-dialog__header {
        padding: 10px;
        background-color: #007bb0;
        
        .el-dialog__title {
          color: #fff;
          font-size: 16px;
        }
        
        .el-dialog__headerbtn {
          top: 13px;
          
          .el-dialog__close {
            color: #fff;
          }
        }
      }
      
      .detail-container {
        max-height: 60vh;
        overflow-y: auto;
        
        .form-section {
          margin-bottom: 20px;
          padding: 10px;
          background: #f8f9fa;
          border-radius: 4px;
          
          .el-form-item {
            margin-bottom: 10px;
          }
        }
        
        .detail-table-section {
          .total-section {
            display: flex;
            align-items: center;
            justify-content: start;
            padding: 10px;
            background: #f5f7fa;
            margin-top: 10px;
            
            span {
              font-size: 14px;
              font-weight: bold;
              margin-right: 10px;
            }
          }
        }
      }
      
      .dialog-footer {
        display: flex;
        justify-content: right;
        padding: 10px 0;
        
        .el-button {
          margin: 0 10px;
        }
      }
    }
  }
  
  // 过渡动画
  .el-zoom-in-center-enter-active,
  .el-zoom-in-center-leave-active {
    transition: all 0.3s cubic-bezier(0.55, 0, 0.1, 1);
  }
  
  .el-zoom-in-center-enter,
  .el-zoom-in-center-leave-active {
    opacity: 0;
  }
  
  // Element UI 样式微调
  .el-table {
    .el-table__header-wrapper {
      th {
        background-color: #f5f7fa;
      }
    }
    
    .el-table__body-wrapper {
      overflow-y: auto;
    }
  }
  
  .el-dialog {
	  border-radius: 8px;
    .el-dialog__header {
      border-bottom: 1px solid #e6e6e6;
      padding: 15px 20px 10px;
      
      .el-dialog__title {
        font-size: 16px;
        font-weight: bold;
      }
    }
	.el-dialog__body{
		padding: 0;
	}
  }
  </style>